export default __webpack_public_path__ + "static/media/2413.57d33a7b.png";